import React, { Component } from 'react'
import sendIcon from '../../../include/images/send-icon.svg'
import { io } from 'socket.io-client'
import { getPatient, loadPatientProfile } from '../../../store/patient'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { chatReceived, chatReceivedAll, getChats, loadChatForDoctor } from '../../../store/chats'
import moment from 'moment'
import { collection, addDoc, serverTimestamp, query, where, orderBy, getDocs, getDoc, doc, updateDoc, } from "firebase/firestore";
import Scrollbars from 'react-custom-scrollbars-2'
import { db } from '../../../firebase'
import { sendMessage } from '../../../chatUtils/chatUtiles'

class Messeges extends Component {
  state = {
    ready: false,
    msgData: '',
    initialBottomScrollDone: false,
  }

  myRef = React.createRef()
  scrollToMyRef = (appointmentDate = "") => {
    if (this.myRef.current) {
      let element = document.getElementById(appointmentDate);

      if (appointmentDate && element && this.props.initial) {
        this.myRef.current.scrollTo(0, element.offsetTop -(document.getElementsByClassName('sidebar-head')[0].offsetHeight + 90))
      } else {
        const chatBox = this.myRef.current;
        const isUserNearBottom =
          chatBox.scrollTop + chatBox.clientHeight >= chatBox.scrollHeight - 100;

        if (isUserNearBottom) {
          chatBox.scrollTo({
            top: chatBox.scrollHeight,
            behavior: "smooth",
          });
        }
      }
    }
  };
  scrollToBottom = () => {
    if (this.myRef.current) {
      this.myRef.current.scrollTo({
        top: this.myRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  };

  loadMessages = async () => {
    if (!this.props.doctor_id || !this.props.patient_id) return;
    const q = query(
      collection(db, "messages"),
      where("sender", "in", [this.props.doctor_id, this.props.patient_id]),
      where("receiver", "in", [this.props.doctor_id, this.props.patient_id]),
      orderBy("created_on", "desc")
    );
    const snapshot = await getDocs(q);
    const msgs = snapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        ...data,
        created_on: data.created_on?.toDate?.().toISOString() || data.created_on,
        time: data.time?.toDate?.().toISOString() || data.time,
      };
    });
    const displayMsgs = msgs.reverse()
    // console.log("msgs----------420---------------> ", displayMsgs)
    this.props.chatReceivedAll(displayMsgs);
    const chatId = `${this.props.doctor_id}_${this.props.patient_id}`;
    const chatDocRef = doc(db, "chatsSummary", chatId);
    const chatDocSnap = await getDoc(chatDocRef);
    // console.log("chatDocSnap ------> ",chatDocSnap)
    if(chatDocSnap.exists() && this.props.tab === 'message'){
      const data = chatDocSnap.data();
      if (data.readByDoctor === false) {
      console.log("i am updating live ---------->")
      await updateDoc(doc(db, "chatsSummary", chatId), {
        readByDoctor: true,
      }, { merge: true });
    }
  }
    // this.scrollToMyRef(false);
  };

  handleSend = async (msg) => {
    if (msg) {
      await sendMessage({
        msg: this.state.msgData,
        doctorId: this.props.doctor_id,
        patientId: this.props.patient_id,
        sender: this.props.doctor_id,
      });
      // this.props.setInitial()
      this.setState({ msgData: "" }, () => {
        this.scrollToBottom();
      });
      this.loadMessages();
    }
  };

  componentWillUnmount = () => {
    clearInterval(this.pollInterval);
  }

  componentDidUpdate = (prevProps, prevState) => {
    console.log("------componentdidUpdate-------")
    if (
      !this.props.appointmentDate &&
      !this.state.initialBottomScrollDone &&
      this.props.chats.length > 0 && this.props.tab === 'message'
      //  &&
      // prevProps.chats.length === 0
    ) {
      console.log("Scrolling to bottom...");
      this.scrollToBottom();
      this.setState({ initialBottomScrollDone: true });
    }
  }

  componentDidMount = () => {
    this.pollInterval = setInterval(() => {
      this.loadMessages();
    }, 5000);
  }
  render() {
    return (
      <>
        <div className="card-header">
          <i className="fa-solid fa-message-dots fa-lg" style={{ color: "#673ab7" }}></i>
          <b>Messages</b>
        </div>
        <div className="content-body show">
          <div className="chat-area">
            <div className="chat" ref={this.myRef}>
              {this.props.chats.map((es, i) => {
                const createdOn = es.created_on?.toDate?.() || es.created_on;
                const time = es.time?.toDate?.() || es.time;
                return (
                <>
                  {(i === 0 ||
                    moment(
                      this.props.chats[i - 1]?.created_on?.toDate?.() ||
                        this.props.chats[i - 1]?.created_on
                    ).format(
                      'DD/MM/YYYY',
                    ) !== moment(createdOn).format('DD/MM/YYYY')) && (
                    <div
                      class="chat-seprator"
                      id={moment(createdOn).format('DD/MM/YYYY')}
                    >
                    <span> {moment(createdOn).format('DD/MM/YYYY')}</span>
                    <div className="alert_box">
                      <div className="alert_box_content">
                      This chat is between you and patient only. YesMindy has no role in the messages exchanged here. Please refrain from advising anything critical over messages and keep it for simple queries or thought journaling. Reach out to YesMindy clinical team for any support needed. 
                      </div>
                      </div>                       
                    </div>
                  )}
                  {this.props.doctor_id === es.sender ? (
                    <div class="chat-message-box send-message">
                      <div>
                        <div class="chat-message">{es.msg || es.message}</div>
                      </div>
                      <div class="time">
                        {moment(createdOn).format('hh:mm:ss A')}{' '}
                      </div>
                    </div>
                  ) : (
                    <div class="chat-message-box received-message d-flex flex-column align-items-end">
                      <div class="d-flex flex-column">
                        <div class="chat-message">{es.msg || es.message}</div>
                      </div>
                      <div class="time">
                        {' '}
                        {moment(time || createdOn).format('hh:mm:ss A')}{' '}
                      </div>
                    </div>
                  )}
                </>
                )
              })}
            </div>
            <div className="send">
              <input
                onChange={(e) => this.setState({ msgData: e.target.value })}
                className="input-message"
                name="msgData"
                value={this.state.msgData}
                placeholder="Write your message…"
                type="text"
                id="message"
                onKeyDown={(e) => {
                  if (e.key === 'Enter') this.handleSend(this.state.msgData)
                }}
              />
              <button
                className="input-send"
                onClick={(e) => {
                  if (this.state.msgData) this.handleSend(this.state.msgData)
                }}
              >
                <i>
                  <img src={sendIcon} alt="" />
                </i>
              </button>
            </div>
          </div>
        </div>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  patientProfile: getPatient(state).profile,
  patientHistory: getPatient(state).history,
  psychiatrist: getPatient(state).psychiatrist,
  psychologist: getPatient(state).psychologist,
  loading: getPatient(state).loading,
  chats: getChats(state).chatData,
  chatLoading: getChats(state).loading,
})
const mapDispatchToProps = (dispatch) => ({
  loadPatientProfile: () => dispatch(loadPatientProfile()),
  chatReceived: (data) => dispatch(chatReceived(data)),
  chatReceivedAll: (data) => dispatch(chatReceivedAll(data)),
  loadChatForDoctor: (id) => dispatch(loadChatForDoctor(id)),
})
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Messeges)
)
